import { DateField } from "@refinedev/antd";
import { theme } from "antd";
import { useTranslation } from "react-i18next";
import { TFunction, i18n as I18nType } from "i18next";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/es";

dayjs.extend(relativeTime);

export const useFormatLastUpdate = () => {
  const { t, i18n }: { t: TFunction; i18n: I18nType } = useTranslation();
  const { token } = theme.useToken();

  const formatLastUpdate = (lastUpdate: string) => {
    const lastUpdatePlus24Hours = dayjs(lastUpdate).add(24, "hours");
    const now = dayjs();

    if (now.isAfter(lastUpdatePlus24Hours)) {
      return (
        <DateField
          locales={i18n.language === "es" ? "es" : "en"}
          style={{ color: token.colorTextSecondary }}
          value={lastUpdate}
          format="LLL"
        />
      );
    } else {
      return (
        <span style={{ color: token.colorTextSecondary }}>
          {" "}
          {i18n.language === "es" ? "Hace" : ""}{" "}
          {dayjs(lastUpdate)
            .locale(i18n.language === "es" ? "es" : "en")
            .fromNow(true)}{" "}
          {i18n.language === "es" ? "" : "ago"}
        </span>
      );
    }
  };

  return formatLastUpdate;
};
